import React, { useRef } from 'react';

//components
import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';
import TooltipDropdownList from  '@/components/elements/global/dropdown/TooltipDropdownList';

//helpers
import { hasEditorPermissions, isOrganisationAdmin } from  '@/helpers/OrgSettings';
import UseUserRolePermissions from './userRolePermissions.hooks';

//interfaces
import { GrantType, ResourcePermission } from  '@/interfaces/orgSettings';
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';

//styling
import "../../../../../css/global/orgSettings/userRolePermissions.scss";


const UserRolePermissions = ({id, appId, permission, grantType}: {id: any, appId?:string, permission: ResourcePermission, grantType: GrantType}) => {
    const {isLoading, groups, displayTooltip, setDisplayTooltip, extraDetailText} = UseUserRolePermissions(id, appId);
    const permissionType = hasEditorPermissions(permission) ? 'Editor' : 'Viewer';
    const dropdownRef = useRef<any>();

    useClickAwayClose(displayTooltip, dropdownRef, ()=> setDisplayTooltip(false));

    return (
        <div className='role-permission-container' ref={dropdownRef} onMouseEnter={() => setDisplayTooltip(true)} onMouseLeave={() => setDisplayTooltip(false)}>
            <button className='role-permission-button' onClick={() => setDisplayTooltip(true)}>
                {permissionType}
                {isOrganisationAdmin(permission, grantType) && <Icon iconName={IconLibrary.USER_COG} sizeInPx='10' color="#343D4C"/>}
            </button>

            <TooltipDropdownList show={displayTooltip} isLoading={isLoading} items={groups} extraDetailText={extraDetailText}/>
        </div>
    )
}

export default UserRolePermissions